/**
 * MultiselectOption
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import clsx from 'clsx';
import React from 'react';
import Icon from '../Icon';
/** Multiselect option. */
var MultiselectOption = function (_a) {
    var id = _a.id, name = _a.name, value = _a.value, checked = _a.checked, count = _a.count, children = _a.children, onChange = _a.onChange, disabled = _a.disabled, className = _a.className, props = __rest(_a, ["id", "name", "value", "checked", "count", "children", "onChange", "disabled", "className"]);
    return (React.createElement("label", { htmlFor: id, className: clsx(className, 'inline-flex items-start mb-4 px-1 text-p leading-5 transition-all duration-300') },
        React.createElement("input", __assign({ type: "checkbox", id: id, name: name, value: value, checked: checked, className: "mr-2 sr-only checkbox", onChange: onChange, disabled: disabled }, props)),
        React.createElement("div", { className: "checkbox__icon--teal flex-shrink-0 inline-flex items-center justify-center w-5 h-5 mr-2 rounded border-2 border-grey cursor-pointer checkbox__icon--teal transition-all duration-300 text-greyDark" }, checked && React.createElement(Icon, { icon: "check", size: 1.25 })),
        React.createElement("span", { className: "mr-2 inline-block w-full" },
            children,
            count !== undefined && (React.createElement("span", { className: "ml-1 text-greyDarker" }, "(" + count + ")")))));
};
export default MultiselectOption;
